
export enum EmploymentModeEnum {
  GTPL = "GTPL",
  SubContractor = "SubContractor"
}
